import type { PivotRowRange } from './types'
import { PIVOT_GRID_OVERSCAN } from './constants'

/** Computes the slice of body rows to render for the current scroll position, with overscan above and below. */
export const computePivotRowRange = ({
  scrollTop,
  viewportHeight,
  rowHeight,
  rowCount,
}: {
  scrollTop: number
  viewportHeight: number
  rowHeight: number
  rowCount: number
}): PivotRowRange => {
  if (rowHeight === 0) return { start: 0, end: Math.min(1, rowCount) }
  const start = Math.max(0, Math.min(rowCount, Math.floor(scrollTop / rowHeight)) - PIVOT_GRID_OVERSCAN)
  const end = Math.min(rowCount, Math.ceil((scrollTop + viewportHeight) / rowHeight) + PIVOT_GRID_OVERSCAN)
  return { start, end }
}
